<template>
  <div
    class="modal fade"
    id="reloadNotification"
    role="dialog"
  >
    <div class="modal-dialog m-t-40vh" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <span>セールモンスターが更新されました。</span>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-warning w-150 mr-r-10"
            data-dismiss="modal"
            @click="reload()"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted () {
    $('#reloadNotification').modal('show')
  },
  methods: {
    reload () {
      this.$emit('reload')
    }
  }
}
</script>
<style scoped>
.m-t-40vh {
  margin-top: 40vh;
}

.modal-body {
  text-align: center;
}
.modal-footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ReloadNotification.vue